import { Action, createReducer, on } from "@ngrx/store";
import { loadJobFulfillmentTypeSuccess } from "../actions/job-fulfillment-type.actions";
import { JobFulfillmentTypeState } from "../state/job-fulfillment-type.state"

const initialState: JobFulfillmentTypeState = {
    jobFulfillmentTypes: []
}
const reducer = createReducer(
    initialState,

    on(loadJobFulfillmentTypeSuccess,
        (state, action) => ({
            ...state,
            jobFulfillmentTypes: action.jobFulfillmentTypes
        }))
);

export function jobFulfillmentTypeReducer(state: JobFulfillmentTypeState | undefined, action: Action) {
    return reducer(state, action);
}
